// TODO: LAUNCH-4050: remove hardcoded locales

/**
 * Gets the correct translation from a commercetools localized string
 * https://docs.commercetools.com/api/types#localizedstring *
 * @param {string} locale - example: nl
 * @param {object} data - localised ctools string object
 */
export const getLocalized = (locale, data) => {
  // Need to revisit this one after converting to TS
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!data) {
    return '';
  }

  if (locale && data[locale]) {
    return data[locale];
  }

  if (data.nl) {
    return data.nl;
  }

  if (data.en) {
    return data.en;
  }

  return '';
};
